import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Controller } from 'react-hook-form';

// Components Styled
import { ContainerOperator } from './styles';
import {
  ContainerBasicInfo,
  InputsContainer,
  Title,
} from '../components/MainStyled';

//Components
import { DateTime } from '../../inputs/DateTime';

// Types
import { FormProps } from './types';
import { Typography } from '../../display/Typography';
import InputText from '../../inputs/InputText';
import SearchableDropdown from '../../inputs/SearchableDropdown';

export const BasicInfo = ({
  register,
  control,
  errors,
  isAction,
  title,
  showOperatorPicker,
  onOperatorChange,
}: FormProps) => {
  const { t } = useTranslation(['forms']);
  const location = useLocation();
  const locationNewOrder = location.pathname !== '/work-orders/new-order';
  return (
    <ContainerBasicInfo>
      <Title component="h2" variant="semiBold">
        {title}
      </Title>
      <InputsContainer>
        <ContainerOperator>
          {showOperatorPicker ? (
            // Duplicar: el autor del duplicado se elige. Arranca en el de la
            // original y el logueado va el primero de la lista (spec
            // 2026-09-24-duplicar-operario-editable § 3).
            <Controller
              control={control}
              name="userId"
              render={({ field: { onChange }, formState: { defaultValues } }) => (
                <SearchableDropdown
                  id="operator-select"
                  labelText={t('workOrder.operator')}
                  placeholder={t('common:select')}
                  inputSize="M"
                  typeDropDown="Default"
                  options={
                    defaultValues?.appUserOptions?.map((user) => ({
                      label: user?.name ?? '',
                      value: user?.id ?? '',
                    })) ?? []
                  }
                  defaultValue={defaultValues?.userId}
                  onChangeSelected={(option) => {
                    onChange(option?.value ?? '');
                    onOperatorChange?.(option?.label ?? '');
                  }}
                  borderError={!!errors.userId}
                />
              )}
            />
          ) : (
            <InputText
              {...register('operator')}
              id="operator-input"
              inputSize="M"
              disabled
              label={t('workOrder.operator')}
              typeInput="normal"
              borderError={!!errors.operator}
            />
          )}
          {locationNewOrder && (
            <Typography size="XXS">
              {t('common:workOrder.lastModification')}: 00/00/0000 o les 00:00
            </Typography>
          )}
        </ContainerOperator>
        {!isAction && (
          <Controller
            control={control}
            name="registerInitDate"
            render={({ field: { onChange }, formState: { defaultValues } }) => (
              <DateTime
                label={t('workOrder.registerDate')}
                labelHour={t('workOrder.hour')}
                onChangeDate={onChange}
                initialDate={
                  defaultValues?.registerInitDate
                    ? defaultValues?.registerInitDate
                    : new Date()
                }
                borderError={!!errors.registerInitDate}
              />
            )}
          />
        )}
      </InputsContainer>
    </ContainerBasicInfo>
  );
};
